var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCorporatePerformanceControl(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m28.02 16.726-.005.007-9.364 11.959a2.836 2.836 0 0 1-4.009-4.01L33.593 9.729l-5.205 6.547-.002.002-.365.448zM20 3.833c3.607 0 7.123 1.1 10.081 3.146l-5.066 3.998a12.887 12.887 0 0 0-8.345-3.144h-.007a12.88 12.88 0 0 0-8.234 3.053L7.135 9.344A17.763 17.763 0 0 1 20 3.834zm11.772 15.149.003-.004 4.186-5.265A17.631 17.631 0 0 1 37.598 24.5H30.5v-1.169a17.346 17.346 0 0 0-.19-2.499l1.076-1.375.386-.475zM8.834 36.178v-2.333H24.5v2.333H8.834zM2.402 24.5a17.572 17.572 0 0 1 2.075-11.583l1.05 1.25a16.641 16.641 0 0 0-2.693 9.168V24.5h-.432z",
    fill: "#C9A87A",
    fillOpacity: 0.16,
    stroke: "url(#8kyr2r0tsa)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "8kyr2r0tsa",
    x1: 28.875,
    y1: 54.542,
    x2: -7.49,
    y2: 38.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporatePerformanceControl);
export default __webpack_public_path__ + "static/media/corporatePerformanceControl.0b9ea869e255d28fca6ae5ce314e473d.svg";
export { ForwardRef as ReactComponent };